export const PRODUCT = 'PLANT NUTRITION VISUAL ATLAS™'

export const PRODUCT_TAGLINE =
  'THE COMPLETE VISUAL PLANT NUTRITION & NUTRIENT DEFICIENCY REFERENCE SYSTEM'

/** Anchor id of the $27 purchase section */
export const OFFER_ANCHOR = '#offer'

export const CHECKOUT_URL = 'https://plant-nutrition-visual-atlas.impultienda.ar/checkout'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/jk5qK6qJst9E9LiL7ehK7W/Diseno-sin-titulo-19.webp'

export const SUPPORT_EMAIL = 'kitonline27@gmail.com'

export const PIXEL_ID = '1514417324213827'
